// GraphQL fragments for reusable field selections

export const automationTimestampsFragment = {
  createdAt: true,
  updatedAt: true,
} as const;

export const positionFragment = {
  x: true,
  y: true,
} as const;

// Node fragments - one for each node type
export const nodeBaseFields = {
  id: true,
  type: true,
  position: positionFragment,
  label: true,
  description: true,
} as const;

export const nodeFragment = {
  ...nodeBaseFields,
  on_HttpWebhookTriggerNode: {
    ...nodeBaseFields,
  },
  on_BusinessEventTriggerNode: {
    ...nodeBaseFields,
    eventType: true,
    filter: true,
  },
  on_ScheduleTriggerNode: {
    ...nodeBaseFields,
    cronExpression: true,
    timezone: true,
  },
  on_EmailActionNode: {
    ...nodeBaseFields,
    to: true,
    subject: true,
    body: true,
    bodyType: true,
    cc: true,
    bcc: true,
    replyTo: true,
  },
  on_HttpRequestActionNode: {
    ...nodeBaseFields,
    url: true,
    method: true,
    headers: true,
    requestBody: true,
    bodyType: true,
    timeout: true,
    retryCount: true,
  },
  on_ConditionNode: {
    ...nodeBaseFields,
    expression: true,
    trueBranchLabel: true,
    falseBranchLabel: true,
  },
  on_DelayNode: {
    ...nodeBaseFields,
    delayType: true,
    duration: true,
    durationUnit: true,
    untilDateTime: true,
    untilExpression: true,
  },
  on_ApprovalNode: {
    ...nodeBaseFields,
    approvers: {
      userIds: true,
      roleIds: true,
    },
    instructions: true,
    timeoutEnabled: true,
    timeoutDuration: true,
    timeoutUnit: true,
    timeoutAction: true,
  },
} as const;

export const edgeFragment = {
  id: true,
  source: true,
  target: true,
  sourceHandle: true,
} as const;

export const triggerConfigFragment = {
  __typename: true,
  on_HttpWebhookTriggerConfigOutput: {
    path: true,
  },
  on_BusinessEventTriggerConfigOutput: {
    entityType: true,
    eventCase: true,
    filterExpression: true,
  },
  on_ScheduleTriggerConfigOutput: {
    cron: true,
  },
} as const;

export const automationBaseFragment = {
  id: true,
  name: true,
  description: true,
  status: true,
  triggerType: true,
  triggerConfig: triggerConfigFragment,
  organizationId: true,
  timestamps: automationTimestampsFragment,
} as const;

export const automationFullFragment = {
  ...automationBaseFragment,
  nodes: nodeFragment,
  edges: edgeFragment,
  workflowId: true,
  workflowRunId: true,
} as const;

export const webhookEndpointFragment = {
  id: true,
  automationId: true,
  path: true,
  secret: true,
  isActive: true,
  lastUsedAt: true,
  timestamps: automationTimestampsFragment,
} as const;

export const executionRunFragment = {
  id: true,
  automationId: true,
  status: true,
  triggeredAt: true,
  triggerPayload: true,
  startedAt: true,
  completedAt: true,
  durationMs: true,
  nodesExecuted: true,
  actionsExecuted: true,
  executionDurationMs: true,
  errorMessage: true,
  workflowId: true,
  workflowRunId: true,
  isTest: true,
  organizationId: true,
  timestamps: automationTimestampsFragment,
} as const;

export const integrationFragment = {
  key: true,
  name: true,
  type: true,
  icon: true,
  category: true,
  operations: {
    key: true,
    name: true,
    description: true,
    inputSchema: true,
  },
} as const;
